export const twilioNumbers = {
  superAdmin: '+16463326692',
  admin: '+16462122477',
  navigator: '+16463326530',
  employmentLiaison: '+16463326236',
};
